// @systeme: interface
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export function Chargement() {
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}
      role="status"
      aria-label="Chargement"
    >
      <CircularProgress color="primary" />
    </Box>
  );
}
